import { render, staticRenderFns } from "./BtnInfo.vue?vue&type=template&id=35237f54&scoped=true"
import script from "./BtnInfo.vue?vue&type=script&lang=js"
export * from "./BtnInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35237f54",
  null
  
)

export default component.exports